import type { ChangeEvent } from "react";
import type { Control } from "react-hook-form";

import { ui } from "@patient-watch/ui";
import type { LooseRHFField } from "./utils/loose-rhf-field";

interface Props {
    control: Control;
    name: string;
    label?: string;
    disabled?: boolean;
    tabIndex?: number;
    min?: number | null;
    max?: number | null;
    step?: number | string;
}

const NumberInput: React.FC<Props> = ({ name, label, control, disabled, tabIndex, min, max, step }) => {
    return (
        <ui.FormField
            control={control}
            name={name}
            disabled={disabled}
            data-cy={name}
            render={({ field }: { field: LooseRHFField }) => (
                <ui.FormItem>
                    {!!label && <ui.FormLabel>{label}</ui.FormLabel>}
                    <ui.FormControl>
                        <ui.Input
                            type="number"
                            tabIndex={tabIndex}
                            data-testid="number-input"
                            value={field.value ?? ""}
                            onChange={(e: ChangeEvent<HTMLInputElement>) => {
                                const val = e.target.value;
                                field.onChange(val === "" ? null : Number.parseFloat(val));
                            }}
                            min={min ?? undefined}
                            max={max ?? undefined}
                            step={step}
                        />
                    </ui.FormControl>
                    <ui.FormMessage />
                </ui.FormItem>
            )}
        />
    );
};

export default NumberInput;
